import { Component, Editor } from "grapesjs";

export default (editor: Editor) => {
  const blockManager = editor.BlockManager;
  const domComponents = editor.DomComponents;
  domComponents.addType("hero-component", {
    model: {
      defaults: {
        tagName: "section",
        classes: ["hero-component"],
        traits: [
          {
            type: "select",
            label: "Background Type",
            name: "backgroundType",
            options: [
              { id: "image", value: "image", name: "Image" },
              { id: "video", value: "video", name: "Video" },
            ],
            changeProp: true,
            default: "image",
          },
          {
            type: "text",
            label: "Background URL",
            name: "backgroundUrl",
            default:
              "https://careersites.talentech.io/assets/images/default-hero.jpg",
            changeProp: true,
          },
          {
            changeProp: true,
            type: "image-selector",
            // @ts-ignore
            buttonText: "SELECT",
            targetTrait: "backgroundUrl",
          },
          {
            type: "color",
            label: "Backdrop Color",
            name: "backdropColor",
            default: "rgba(0, 0, 0, 0.5)",
            changeProp: true,
          },
          {
            type: "checkbox",
            label: "Content Backdrop",
            name: "hasBackdrop",
            default: true,
            changeProp: true,
          },
        ],
        components: [
          {
            tagName: "div",
            style: {
              position: "relative",
              "z-index": 1,
            },
            classes: ["container-fluid"],
            components: [
              {
                type: "box",
                components: [
                  {
                    type: "box",
                    components: [
        
                          {
                            type: "heading",
                            content: "Welcome to Our Website",
                          },
                          {
                            type: "text",
                            tagName: "p",
                            content:
                              "This is a hero section with a background image or video.",
                            
                          },
                    ], 
                    classes: ["col"],
                  },  
                ],
                classes: ["row"],
              },
              
            ],
          },
        ],
        style: {
          "min-height": "100vh",
          position: "relative", 
          overflow: "hidden",
          display: "flex",
          "flex-direction": "column",
          "justify-content": "center",
          "align-items": "center",
          color: "#fff",
        },
      },
      init() {
        this.ensureBackdropStyles();
        this.listenTo(
          this,
          "change:backgroundType change:backgroundUrl change:backdropColor change:hasBackdrop",
          this.updateBackground
        );
        setTimeout(() => {
          this.updateBackground();
        }, 100);
      },
      updateBackground() {
        const backgroundType = this.get("backgroundType");
        const backgroundUrl = this.get("backgroundUrl");
        const backdropColor = this.get("backdropColor");
        const hasBackdrop = this.get("hasBackdrop");
        const isBackdropChecked =
          hasBackdrop === undefined ||
          hasBackdrop === true ||
          hasBackdrop === "true" ||
          hasBackdrop === "1";
        const normalizedBackdrop =
          typeof backdropColor === "string" ? backdropColor.trim() : "";
        const isBackdropEnabled =
          isBackdropChecked &&
          normalizedBackdrop !== "" &&
          normalizedBackdrop !== "transparent";
        const style = this.getStyle();

        if (backgroundType === "image") {
          style["background-image"] = `url(${backgroundUrl})`;
          style["background-size"] = "cover";
          style["background-position"] = "center";
          this.components().remove(
            this.components().find(
              (el: Component) => el.get("tagName") === "video"
            )
          );
        } else if (backgroundType === "video") {
          delete style["background-image"];
          delete style["background-size"];
          delete style["background-position"];
          let videoComponent = this.components().find(
            (el: Component) => el.get("tagName") === "video"
          );
          const videoAttributes = {
            src: backgroundUrl,
            autoplay: true,
            playsinline: true,
            loop: true,
            muted: true,
            style:
              "position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;",
          };
          if (!videoComponent) {
            videoComponent = this.components().add({
              tagName: "video",
              attributes: videoAttributes,
            });
          } else {
            videoComponent.setAttributes(videoAttributes);
          }

          const videoEl = videoComponent.getEl() as HTMLVideoElement;
          if (videoEl) {
            setTimeout(() => {
              videoEl.muted = true;
              videoEl.volume = 0;
            }, 100);
          }
        }

        this.setStyle(style);
        this.updateBackdrop(isBackdropEnabled, normalizedBackdrop);
      },
      updateBackdrop(hasBackdrop: boolean, backdropColor: string) {
        const classes = this.getClasses();
        const hasClass = classes.includes("hero-component--backdrop");

        if (hasBackdrop && !hasClass) {
          this.addClass("hero-component--backdrop");
        }

        if (!hasBackdrop && hasClass) {
          this.removeClass("hero-component--backdrop");
        }

        this.addStyle({
          "--hero-backdrop-color":
            backdropColor && backdropColor !== "transparent"
              ? backdropColor
              : "rgba(0, 0, 0, 0.5)",
        });
      },
      ensureBackdropStyles() {
        if (this.get("backdropStylesAdded")) {
          return;
        }

        const editorInstance = this.em.getEditor();
        const componentId = this.getId();

        editorInstance.CssComposer.addRules(`
          #${componentId}.hero-component--backdrop::before {
            content: "";
            position: absolute;
            inset: 0;
            background-color: var(--hero-backdrop-color, rgba(0, 0, 0, 0.5));
            pointer-events: none;
            z-index: 1;
          }
        `);

        this.set("backdropStylesAdded", true);
      },
    },
  });

  // Add the Hero block
  blockManager.add("hero-block", {
    label: "Hero",
    content: {
      type: "hero-component",
    },
    media: `<i class="fa-sharp fa-light fa-display fs-2"></i>`,
    category: "Basic",
  });
};
